import * as actionTypes from '../Global_action.types';

const initialState = {
  loggingIn: false,
  downloadSelectedIds: [],
  error: null,
  message: '',
};
const DownloadSelectedIDsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.DOWNLOAD_SELECTED_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.DOWNLOAD_SELECTED_SUCCESS:
      return {
        ...state,
        loading: false,
        downloadSelectedIds: action.payload,

      }

    case actionTypes.DOWNLOAD_SELECTED_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default DownloadSelectedIDsReducer
